import React from "react";
import trophy from "../../../assets/img/trophy.svg";

function LeaderboardComponentTwo({ title, playerStats, statistics }) {
  return (
    <div className="border-[1px] border-[#EAEDF0] rounded-lg border-solid w-full ">
      <div className="p-[12px] h-[52px] bg-[#0F1A24] text-[white] text-sm font-bold rounded-t-lg w-full flex items-center">
        <img src={trophy} alt="trophy" />
        <span className="ml-4">{title}</span>
      </div>
      <div className="flex justify-between bg-[#F3F5F7]">
        <div
          className="p-[12px] w-[12.5%] text-center font-bold"
          style={{ border: "1px solid #EAEDF0" }}
        >
          Rank
        </div>
        <div
          className="p-[12px] w-[25%] text-center font-bold"
          style={{ border: "1px solid #EAEDF0" }}
        >
          Player
        </div>
        <div
          className="p-[12px] w-[12.5%] text-center font-bold"
          style={{ border: "1px solid #EAEDF0" }}
        >
          Execution %
        </div>
        <div
          className="p-[12px] w-[12.5%] text-center font-bold"
          style={{ border: "1px solid #EAEDF0" }}
        >
          Busts
        </div>
        <div
          className="p-[12px] w-[12.5%] text-center font-bold"
          style={{ border: "1px solid #EAEDF0" }}
        >
          Efforts %
        </div>
        <div
          className="p-[12px] w-[12.5%] text-center font-bold"
          style={{ border: "1px solid #EAEDF0" }}
        >
          Loafs
        </div>
        <div
          className="p-[12px] w-[12.5%] text-center font-bold"
          style={{ border: "1px solid #EAEDF0" }}
        >
          Overall %
        </div>
      </div>
      <div className="lg:h-[248px] lg:overflow-y-scroll text-xs rounded-b-lg w-full">
        {playerStats
          ?.filter((player) =>
            statistics?.some(
              (stat) =>
                Number(player[stat]) !== 0 &&
                player[stat] !== undefined &&
                player[stat] !== "0.0%"
            )
          )
          .sort((a, b) => b.busts - a.busts)
          ?.map((player, index) => (
            <div
              key={index}
              className={`flex  ${
                index === 0 ? "bg-[#F0A922]" : "bg-[#FCFCFD]"
              } text-[#0F1A24] w-full font-[400]`}
            >
              <div
                className="p-[12px] flex items-center justify-center w-[12.5%]"
                style={{ border: "1px solid #EAEDF0" }}
              >
                <span>{index + 1}</span>
              </div>
              <div
                className="p-[12px] text-center flex items-center justify-center w-[25%]"
                style={{ border: "1px solid #EAEDF0" }}
              >
                <span>{`${player.first_name} ${player.last_name}`}</span>
              </div>
              {statistics?.map((stat, idx) => (
                <div
                  key={idx}
                  className="p-[12px] flex items-center justify-center w-[12.5%]"
                  style={{ border: "1px solid #EAEDF0" }}
                >
                  <span>{player[stat]}</span>
                </div>
              ))}
            </div>
          ))}
        {playerStats?.filter((player) =>
          statistics?.some(
            (stat) => Number(player[stat]) !== 0 && player[stat] !== undefined
          )
        ).length === 0 && (
          <div className="text-center py-4 text-[#0F1A24] text-lg flex items-center justify-center h-full">
            No data available
          </div>
        )}
      </div>
    </div>
  );
}

export default LeaderboardComponentTwo;
